module.exports = __webpack_public_path__ + "img/logo_secondary-small-black.de630ec4.svg";